import * as Yup from "yup";

export const followUpValidationSchema = Yup.object({
  follow_up_remarks: Yup.string().required("Follow Up Remarks is required"),
  follow_up_person: Yup.string().required("Follow Up Person is required"),
});
